module.exports = __webpack_public_path__ + "static/media/270.59778013.wav";